module.exports = __webpack_public_path__ + "assets/img/status-ontime-wcag.39a40b4a.svg";